import React, { useMemo, useState } from 'react'
import Select from 'react-select'
import { Td, Tr } from '../table'
import style from '../fast-configuration-modal/fastConfigurationModal.css'
import useTranslation from '../../hooks/useTranslation'
import EquipmentGroup from '../../entities/EquipmentGroup'
import EquipmentFamily from '../../entities/EquipmentFamily'
import Equipment from '../../entities/Equipment'

const FastConfigurationExteriorAutocomplete = ({
    equipmentGroups,
    selectedExteriorColor,
    selectedModel,
    setSelectedExteriorColor,
    isLoading,
}) => {
    const { t } = useTranslation()
    const [exteriorInputValue, setExteriorInputValue] = useState('')

    const exteriorColorOptions = useMemo(() => {
        const optionsMap = new Map()

        equipmentGroups
            .flatMap((group: EquipmentGroup) => group.equipmentFamilies)
            .flatMap((family: EquipmentFamily) => family.equipments)
            .filter((equipment: Equipment) => equipment.id.startsWith('F14'))
            .forEach((equipment: Equipment) => {
                if (!optionsMap.has(equipment.id)) {
                    optionsMap.set(equipment.id, {
                        value: equipment.id,
                        label: equipment.id,
                    })
                }
            })

        return Array.from(optionsMap.values())
    }, [equipmentGroups])

    const filteredExteriorColorOptions = useMemo(
        () =>
            exteriorInputValue.length >= 2
                ? exteriorColorOptions.filter((option) =>
                      option.label.toLowerCase().includes(exteriorInputValue.toLowerCase()),
                  )
                : [],
        [exteriorInputValue, exteriorColorOptions],
    )

    return (
        <Tr>
            <Td className={style.noBorder}>
                <div className={style.explanationContainer}>
                    <h4 className={style.explanationHeading}>{t('fastConfigurationModal.exteriorTitle')}</h4>
                    <span className={style.explanation}>{t('fastConfigurationModal.exteriorExplanation')}</span>
                </div>
            </Td>
            <Td className={style.noBorder}>
                <Select
                    options={filteredExteriorColorOptions}
                    value={selectedExteriorColor}
                    onChange={(selected) => setSelectedExteriorColor(selected || null)}
                    onInputChange={(value) => setExteriorInputValue(value)}
                    isSearchable
                    isClearable
                    isDisabled={isLoading || selectedModel == null}
                    placeholder=""
                    className={style.input}
                    classNamePrefix="fastConfig"
                    components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                    }}
                    noOptionsMessage={() =>
                        exteriorInputValue.length < 2
                            ? t('fastConfigurationModal.atLeastTwoCharacters')
                            : t('fastConfigurationModal.noExteriorColor')
                    }
                />
            </Td>
        </Tr>
    )
}

export default FastConfigurationExteriorAutocomplete
